import { z } from 'zod';
/** WebSocket メッセージのスキーマ。すべての受信メッセージはこれで検証する。 */
export const RoomCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{4,8}$/);
export const SettingsPatchSchema = z
    .object({
    rounds: z.number().int().min(1).max(30),
    level: z.union([z.literal(1), z.literal(2), z.literal(3)]),
    hint: z.boolean(),
    drawSeconds: z.number().int().min(8).max(90),
    finalSeconds: z.number().int().min(0).max(30),
    countdownSeconds: z.number().int().min(0).max(5),
    audioTarget: z.enum(['host', 'players', 'both']),
    ttsRate: z.number().min(0.6).max(1.4),
    gapMs: z.number().int().min(300).max(5000),
    listed: z.boolean(),
    wrongPenalty: z.number().int().min(0).max(300),
    autoReveal: z.boolean(),
})
    .partial();
export const ClientMessageSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('hello'),
        role: z.enum(['host', 'player']),
        roomCode: RoomCodeSchema,
        /** role=host のとき必須 */
        hostToken: z.string().min(8).max(128).optional(),
        /** role=player: 再接続用 */
        playerToken: z.string().min(8).max(128).optional(),
        name: z.string().min(1).max(40).optional(),
    }),
    z.object({ type: z.literal('ping'), t: z.number() }),
    z.object({ type: z.literal('settings:update'), patch: SettingsPatchSchema }),
    z.object({ type: z.literal('game:start') }),
    z.object({ type: z.literal('audio:done') }),
    z.object({ type: z.literal('audio:failed') }),
    z.object({ type: z.literal('audio:retry') }),
    z.object({ type: z.literal('audio:progress'), letterIndex: z.number().int().min(0).max(3) }),
    z.object({ type: z.literal('audio:replay') }),
    z.object({ type: z.literal('audio:skip') }),
    z.object({ type: z.literal('round:next') }),
    z.object({ type: z.literal('game:end') }),
    z.object({ type: z.literal('game:reset') }),
    z.object({ type: z.literal('player:kick'), playerId: z.string().min(1).max(64) }),
    /** 参加者が自分の表示名を変える（接続し直さない） */
    z.object({ type: z.literal('player:rename'), name: z.string().min(1).max(40) }),
    /** 参加者が A〜D を押す。押した時点で回答確定（1 ラウンド 1 回、変更不可） */
    z.object({ type: z.literal('answer'), letterIndex: z.number().int().min(0).max(3) }),
]);
export const MAX_PLAYERS = 60;
export const MAX_MESSAGE_BYTES = 4096;
/** REST: ルーム作成 */
export const CreateRoomResponseSchema = z.object({
    code: z.string(),
    hostToken: z.string(),
});
export const RoomInfoResponseSchema = z.object({
    code: z.string(),
    phase: z.string(),
    players: z.number(),
    joinable: z.boolean(),
});
//# sourceMappingURL=protocol.js.map